import { render } from "./PrecedentSearchModal.vue?vue&type=template&id=485c2e61&scoped=true&ts=true"
import script from "./PrecedentSearchModal.vue?vue&type=script&lang=ts"
export * from "./PrecedentSearchModal.vue?vue&type=script&lang=ts"

import "./PrecedentSearchModal.vue?vue&type=style&index=0&id=485c2e61&lang=scss&scoped=true"
import "./PrecedentSearchModal.vue?vue&type=style&index=1&id=485c2e61&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485c2e61"]])

export default __exports__